<template>
  <div class="search-container">
    <div class="visual-search">
      <div class="visual_search_wrapper grid cross-center" ref="searchTarget">
        <span
          class="search_value_wrapper grid cross-center"
          v-for="(selected, index) in selectedValues"
          :key="index"
          :class="selected.key"
        >
          <span class="search-label hor-margin-10">{{ selected.name }}</span>

          <!-- custom_params -->
          <span
            v-if="selected.type == 'text' && selected.is_cp == true"
            class="u grid"
          >
            <el-input
              v-model.trim="cp[selected.key]"
              v-show="showInput"
              class="input_text_value u"
              @change="onValueChange($event, selected)"
              clearable
            ></el-input>
          </span>

          <!-- map_order_id -->
          <span
            v-if="selected.type == 'text' && selected.key == 'map_orders'"
            class="u grid"
          >
            <el-input
              v-model="map_orders"
              v-show="showInput"
              class="input_text_value u"
              @change="onValueChange($event, selected)"
              clearable
            ></el-input>
          </span>
          <!-- merchant_order_id -->
          <span
            v-if="selected.type == 'text' && selected.key == 'merchant_orders'"
            class="u grid"
          >
            <el-input
              v-model="merchant_orders"
              v-show="showInput"
              class="input_text_value u"
              @change="onValueChange($event, selected)"
              clearable
            ></el-input>
          </span>
          <!-- pan_masks -->
          <span
            v-if="selected.type == 'text' && selected.key == 'pan_masks'"
            class="u grid"
          >
            <el-input
              v-model="pan_masks"
              v-show="showInput"
              class="input_text_value u"
              @change="onValueChange($event, selected)"
              clearable
              v-mask="'######******#######'"
            ></el-input>
          </span>
          <!-- card_holders -->
          <span
            v-if="selected.type == 'text' && selected.key == 'card_holders'"
            class="u grid"
          >
            <el-input
              v-model="card_holders"
              v-show="showInput"
              class="input_text_value u"
              @change="onValueChange($event, selected)"
              clearable
            ></el-input>
          </span>
          <!-- rrns -->
          <span
            v-if="selected.type == 'text' && selected.key == 'rrns'"
            class="u grid"
          >
            <el-input
              v-model="rrns"
              v-show="showInput"
              class="input_text_value u"
              @change="onValueChange($event, selected)"
              clearable
            ></el-input>
          </span>
          <!-- bank_names -->
          <span
            v-if="selected.type == 'select' && selected.key == 'bank_names'"
            class="u grid"
          >
            <el-select
              v-model="request.bank_names"
              multiple
              clearable
              collapse-tags
              placeholder
              filterable
              @change="onValueChange($event, selected)"
              class="u"
            >
              <el-option
                v-for="(item, key) in bankList"
                :key="key"
                :label="item"
                :value="key"
              ></el-option>
            </el-select>
          </span>
          <!-- amount_range -->
          <span
            v-if="selected.type == 'text' && selected.key == 'amount_range'"
            class="grid cross-center"
          >
            <el-input-number
              :precesion="2"
              v-model.lazy="amount_From"
              :controls="showControls"
              :min="0"
              @change="onAmountChange($event, selected)"
            ></el-input-number>
            <span class="hor-margin-5">-</span>
            <el-input-number
              :precesion="2"
              v-model.lazy="amount_To"
              :controls="showControls"
              :min="0"
              @change="onAmountChange($event, selected)"
            ></el-input-number>
          </span>
          <!-- merchants  -->
          <span
            v-else-if="selected.type == 'select' && selected.key == 'merchants'"
            class="u grid"
          >
            <el-select
              v-model="request.merchants"
              multiple
              collapse-tags
              placeholder
              filterable
              @change="onValueChange($event, selected)"
              class="u"
            >
              <el-option
                v-for="item in merchantList"
                :key="item.id"
                :label="item.human_name"
                :value="item.id"
              ></el-option>
            </el-select>
          </span>
          <!-- terminals -->
          <span
            v-else-if="selected.type == 'select' && selected.key == 'terminals'"
            class="u grid"
          >
            <el-select
              v-model="request.terminals"
              multiple
              collapse-tags
              placeholder
              filterable
              @input="onValueChange($event, selected)"
              class="u"
            >
              <el-option
                v-for="item in termList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </span>
          <!-- split_terminals -->
          <span
            v-else-if="
              selected.type == 'select' && selected.key == 'split_terminals'
            "
            class="u grid"
          >
            <el-select
              v-model="request.split_terminals"
              multiple
              collapse-tags
              placeholder
              filterable
              @input="onValueChange($event, selected)"
              class="u"
            >
              <el-option
                v-for="item in splitTermList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </span>
          <!-- processing -->
          <span
            v-else-if="
              selected.type == 'select' && selected.key == 'processings'
            "
            class="u grid"
          >
            <el-select
              v-model="request.processings"
              multiple
              collapse-tags
              placeholder
              filterable
              @input="onValueChange($event, selected)"
              class="u"
            >
              <el-option
                v-for="item in processingList"
                :key="item.id"
                :label="item.human_name"
                :value="item.id"
              ></el-option>
            </el-select>
          </span>
          <!-- state_id -->
          <span
            v-else-if="selected.type == 'select' && selected.key == 'states'"
            class="u grid"
          >
            <el-select
              v-model="request.states"
              multiple
              collapse-tags
              placeholder
              filterable
              @input="onValueChange($event, selected)"
              class="u"
            >
              <el-option
                v-for="item in filterStatusList"
                :key="item.id"
                :label="item.human_name"
                :value="item.id"
              ></el-option>
            </el-select>
          </span>
          <!-- processing_errors -->
          <span
            v-else-if="
              selected.type == 'select' && selected.key == 'processing_errors'
            "
            class="u grid"
          >
            <el-select
              v-model="request.processing_errors"
              multiple
              collapse-tags
              clearable
              placeholder
              filterable
              @input="onValueChange($event, selected)"
              class="u"
            >
              <el-option
                v-for="(value, key) in errorList"
                :key="key"
                :label="key"
                :value="key"
              ></el-option>
            </el-select>
          </span>
          <!-- antifraud_decision -->
          <span
            v-else-if="
              selected.type == 'select' && selected.key == 'antifraud_decisions'
            "
            class="u grid"
          >
            <el-select
              v-model="request.antifraud_decisions"
              multiple
              collapse-tags
              placeholder
              @input="onValueChange($event, selected)"
              class="u"
            >
              <el-option
                v-for="item in decisionList"
                :key="item.id"
                :label="item.human_name"
                :value="item.id"
              ></el-option>
            </el-select>
          </span>
          <!-- date_range -->
          <span v-else-if="selected.type == 'date'" class="grid cross-center u">
            <el-date-picker
              v-model="request.date_range"
              :clearable="clearable"
              type="datetimerange"
              range-separator="–"
              start-placeholder="от"
              end-placeholder="до"
              format="dd.MM.yyyy HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              :default-value="defaultMonths"
              :picker-options="pickerOptions"
              @input="onValueChange($event, selected)"
            ></el-date-picker>
          </span>
          <!-- is_payout -->
          <span
            v-else-if="selected.type == 'bool' && selected.key == 'is_payout'"
            class="grid cross-center u"
          >
            <el-switch
              v-model="request.is_payout"
              active-text="Да"
              inactive-text="Нет"
              @input="onValueChange($event, selected)"
            ></el-switch>
          </span>

          <!-- is_ips -->
          <span
            v-else-if="selected.type == 'bool' && selected.key == 'is_ips'"
            class="grid cross-center u"
          >
            <el-switch
              v-model="request.is_ips"
              active-text="Да"
              inactive-text="Нет"
              @input="onValueChange($event, selected)"
            ></el-switch>
          </span>

          <!-- is_recurrent -->
          <span
            v-else-if="
              selected.type == 'bool' && selected.key == 'is_recurrent'
            "
            class="grid cross-center u"
          >
            <el-switch
              v-model="request.is_recurrent"
              active-text="Да"
              inactive-text="Нет"
              @input="onValueChange($event, selected)"
            ></el-switch>
          </span>
          <!-- is_receipt -->
          <span
            v-else-if="selected.type == 'bool' && selected.key == 'is_receipt'"
            class="grid cross-center u"
          >
            <el-switch
              v-model="request.is_receipt"
              active-text="С чеком"
              inactive-text="Без чека"
              @input="onValueChange($event, selected)"
            ></el-switch>
          </span>

          <span
            class="value_close hor-padding-10"
            @mousedown="onCancelClick(selected, index)"
            v-if="!(isReport && selected.key == 'date_range')"
          >
            <b-icon icon="close-circle" size="is-small"></b-icon>
          </span>
        </span>
        <InputSearch
          :searchPlaceholder="isReport ? 'Выбрать по' : 'Добавить фильтр'"
          :removeOnSelect="removeOnSelect"
          :optionList="optionList"
          :termList="termList"
          v-on:onOptionClick="onOptionClick"
          ref="InputSearch"
          :isReport="isReport"
          :isSplits="isSplits"
        />
        <div v-if="!isReport">
          <button
            class="btn search-btn"
            @click.prevent="applyFilters"
            :disabled="loading"
          >
            Применить
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import moment from "moment-timezone";

import underscore from "vue-underscore";
import { _ } from "vue-underscore";
import { mask } from "vue-the-mask";

import SearchComponent from "@/components/SearchComponent";
import InputSearch from "@/components/InputSearch";

import errors from "@/localize/errors.js";
import banks from "@/localize/banks.js";

export default {
  props: [
    "processingList",
    "terminalList",
    "merchantList",
    "statusList",
    "decisionList",
    "isReport",
    "isSplits",
    "isClick",
    "loading"
  ],
  name: "VisualSearch",
  data() {
    return {
      request: {
        date_range: [],
        merchants: [],
        terminals: [],
        split_terminals: [],
        states: [],
        processings: [],
        processing_errors: [],
        bank_names: [],
        antifraud_decisions: [],
        is_payout: false,
        is_recurrent: false,
        is_receipt: false
      },
      cp: {},

      map_orders: "",
      merchant_orders: "",
      pan_masks: "",
      card_holders: "",
      rrns: "",
      amount_From: 0,
      amount_To: 0,
      amount_range: [],
      BankProcessing: "",
      bankList: { ...banks },
      clearable: false,
      showControls: false,
      showInput: true,
      removeOnSelect: true,
      selectedValues: [],
      maslToken: {},
      pickerOptions: {
        disabledDate(time) {
          time = moment(time).format("YYYY-MM-DD");
          return new Date(time).getTime() > new Date().getTime();
        },
        shortcuts: [
          {
            text: "Сегодня",
            onClick(picker) {
              let end = moment()
                .millisecond(0)
                .second(59)
                .minute(59)
                .hour(23)
                .toDate();
              let start = moment()
                .millisecond(0)
                .second(0)
                .minute(0)
                .hour(0)
                .toDate();
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Вчера",
            onClick(picker) {
              let start = moment()
                .add(-1, "days")
                .millisecond(0)
                .second(0)
                .minute(0)
                .hour(0)
                .toDate();
              let end = moment()
                .add(-1, "days")
                .millisecond(0)
                .second(59)
                .minute(59)
                .hour(23)
                .toDate();
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Неделя",
            onClick(picker) {
              let end = moment()
                .millisecond(0)
                .second(59)
                .minute(59)
                .hour(23)
                .toDate();
              let start = moment()
                .add(-1, "weeks")
                .millisecond(0)
                .second(0)
                .minute(0)
                .hour(0)
                .toDate();
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Месяц",
            onClick(picker) {
              let end = moment()
                .millisecond(0)
                .second(59)
                .minute(59)
                .hour(23)
                .toDate();
              let start = moment()
                .add(-1, "months")
                .millisecond(0)
                .second(0)
                .minute(0)
                .hour(0)
                .toDate();
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  methods: {
    loadFilters() {
      if (this.isReport) {
        if (localStorage.getItem("report_filters")) {
          this.selectedValues = JSON.parse(
            localStorage.getItem("report_filters")
          );
          if (this.selectedValues.length > 0) {
            this.selectedValues.forEach(el => {
              let item = this.optionList.find(i => i.key == el.key);
              if (!item) {
                let index = this.selectedValues.indexOf(el);
                this.selectedValues.splice(index, 1);
              }
              if (el.hasOwnProperty("is_cp")) {
                this.cp[el.key] = el.value;
              } else {
                if (el.key == "amount_range") {
                  this.amount_From = el.value[0] / 100;
                  this.amount_To = el.value[1] / 100;
                } else {
                  if (_.isArray(el.value))
                    this.request[el.key] = [].concat(el.value);
                  if (_.isBoolean(el.value)) this.request[el.key] = el.value;
                  if (_.isString(el.value)) {
                    if (el.hasOwnProperty("is_cp") && el.is_cp == true)
                      this.cp[el.key] == el.value;
                    else this[el.key] = el.value;
                  }
                }
              }
              const q = _.findWhere(this.optionList, { key: el.key });
              if (q != undefined) q.show = false;
            });
            this.onUpdateFilter();
          }
        } else {
          this.setDefaultOptions();
        }
      } else if (this.isSplits) {
        if (
          localStorage.getItem("splits_filters") != null &&
          localStorage.getItem("splits_filters") != undefined
        ) {
          this.selectedValues = JSON.parse(
            localStorage.getItem("splits_filters")
          );
          if (this.selectedValues.length > 0) {
            this.selectedValues.forEach(el => {
              if (el.key == "amount_range") {
                this.amount_From = el.value[0] / 100;
                this.amount_To = el.value[1] / 100;
              } else {
                if (_.isArray(el.value))
                  this.request[el.key] = [].concat(el.value);
                if (_.isBoolean(el.value)) this.request[el.key] = el.value;
                if (_.isString(el.value)) {
                  if (el.hasOwnProperty("is_cp") && el.is_cp == true)
                    this.cp[el.key] == el.value;
                  else this[el.key] = el.value;
                }
              }

              const q = _.findWhere(this.optionList, { key: el.key });
              if (q != undefined) q.show = false;
            });
            this.onUpdateFilter();
          }
        }
      } else {
        if (
          localStorage.getItem("filters") != null &&
          localStorage.getItem("filters") != undefined
        ) {
          this.selectedValues = JSON.parse(localStorage.getItem("filters"));
          if (this.selectedValues.length > 0) {
            this.selectedValues.forEach(el => {
              let item = this.optionList.find(i => i.key == el.key);
              if (!item) {
                let index = this.selectedValues.indexOf(el);
                this.selectedValues.splice(index, 1);
              }
              if (el.hasOwnProperty("is_cp")) {
                this.cp[el.key] = el.value;
              } else {
                if (el.key == "amount_range") {
                  this.amount_From = el.value[0] / 100;
                  this.amount_To = el.value[1] / 100;
                } else {
                  if (_.isArray(el.value))
                    this.request[el.key] = [].concat(el.value);
                  if (_.isBoolean(el.value)) this.request[el.key] = el.value;
                  if (_.isString(el.value)) {
                    if (el.hasOwnProperty("is_cp") && el.is_cp == true)
                      this.cp[el.key] == el.value;
                    else this[el.key] = el.value;
                  }
                }
              }
              const q = _.findWhere(this.optionList, { key: el.key });
              if (q != undefined) q.show = false;
            });
            this.onUpdateFilter();
          }
        }
      }
    },
    onOptionClick(option) {
      this.selectedValues.push(option);
      _.findWhere(this.optionList, { key: option.key }).show = false;
    },

    onCancelClick(selected, index) {
      let item = _.findWhere(this.optionList, { key: selected.key });
      if (item) {
        item.show = true;
        if (item.type == "bool") item["value"] = false;
        else if (item.type == "select") item["value"].length = 0;
        else {
          this[item.key] = "";
          this.cp[item.key] = "";
          item.value = "";
        }
        if (selected.key == "amount_range") {
          this.amount_From = 0;
          this.amount_To = 0;
        }
        if (selected.key == "is_payout") selected.value = false;

        this.request[item.key] = _.isArray(this.request[item.key]) ? [] : false;

        this.selectedValues = _.without(this.selectedValues, selected);
        this.saveLocalSorage();
        this.onUpdateFilter(false);
      }
    },
    onAmountChange($event, data) {
      const amount = [];
      amount[0] = this.amount_From
        ? Math.round(((this.amount_From * 10) / 10) * 100)
        : 0;
      amount[1] = this.amount_To
        ? Math.round(((this.amount_To * 10) / 10) * 100)
        : 0;
      this.onValueChange(amount, data);
    },
    applyFilters() {
      if (!this.loading) {
        this.saveLocalSorage();
        this.onUpdateFilter();
      } else {
      }
    },
    onValueChange($event, data) {
      let val = $event;
      if (_.isBoolean(val)) data["value"] = false;
      if (_.isArray(val)) data["value"] = [];
      if (_.isString(val)) data["value"] = "";

      if (_.isArray(val)) {
        data["value"] = data["value"].concat(val);
      } else {
        data["value"] = val;
      }

      if (this.isReport) {
        this.saveLocalSorage();
        this.onUpdateFilter();
      }
    },
    onUpdateFilter(param) {
      let flag = param == false ? param : true;
      const selectedValue = this.selectedValues.slice();
      const req = {};

      if (selectedValue.length > 0) {
        let temp = {};
        selectedValue.forEach(item => {
          if (!item.hasOwnProperty("is_cp")) {
            if (_.isArray(item.value)) {
              if (item.value.length > 0) req[item.key] = item.value;
              else if (req[item.key]) delete req[item.key];
            } else if (_.isBoolean(item.value)) {
              if (item.key == "is_receipt") {
                req[item.key] = item.value;
              } else {
                if (item.value == true) req[item.key] = item.value;
                else delete req[item.key];
              }
            } else {
              if (item.value.length > 0) req[item.key] = [].concat(item.value);
              else delete req[item.key];
            }
          }
        });

        if (req.date_range) {
          let range = [...req.date_range];
          if (this.isReport == true) {
            req.date_range[0] =
              moment.utc(range[0]).format("YYYY-MM-DDTHH:mm:ss.000") + "Z";
            req.date_range[1] =
              moment.utc(range[1]).format("YYYY-MM-DDTHH:mm:ss.000") + "Z";
          } else {
            let start = moment(new Date(range[0]));
            let end = moment(new Date(range[1]));

            req.date_range[0] =
              start.utc().format("YYYY-MM-DDTHH:mm:ss.000") + "Z";
            req.date_range[1] =
              end.utc().format("YYYY-MM-DDTHH:mm:ss.000") + "Z";
          }
          // req.date_range = (this.isReport) ? req.date_range.map(el => moment.utc(el).format("YYYY-MM-DDTHH:mm:ss.000") + "Z") : req.date_range.map(el => moment(el, "YYYY-MM-DD HH:mm:ss").tz("Europe/Moscow"))
        }

        if (req.is_receipt != undefined) {
          req.is_receipt = req.is_receipt ? 1 : -1;
        }

        if (!_.isEmpty(this.cp)) {
          let cp = _.map(this.cp, (val, key) => {
            if (val != "") return { k: key, v: val };
          });
          cp = _.reject(cp, el => el == null);
          if (cp.length > 0) {
            req.custom_params = cp;
          } else {
            if (req.hasOwnProperty("custom_params"))
              delete req["custom_params"];
          }
        }
      }
      this.$emit("saveSearchParams", req);
      if (flag) this.$emit("loadAsyncData", req);
      if (this.isReport) this.$emit("sendRequest", req);
    },

    resetOptions() {
      return this.optionList.map(item => {
        item.show = true;
      });
    },

    setDefaultOptions() {
      if (this.isReport) {
        const defaultOptions = ["Дата"];
        defaultOptions.forEach(el => {
          let q = _.findWhere(this.selectedValues, el);
          let option = _.findWhere(this.optionList, el);
          if (q == undefined) {
            this.onOptionClick(option);

            let start = moment()
              .add(-1, "days")
              .millisecond(0)
              .second(0)
              .minute(0)
              .hour(0)
              .toDate();
            let end = moment()
              .add(-1, "days")
              .millisecond(0)
              .second(59)
              .minute(59)
              .hour(23)
              .toDate();

            let s = moment(start).format("YYYY-MM-DD HH:mm:ss");
            let e = moment(end).format("YYYY-MM-DD HH:mm:ss");

            this.onValueChange([s, e], option);
            this.request.date_range = [s, e];
          }
        });
      }
    },

    saveLocalSorage() {
      if (this.selectedValues.length > 0) {
        if (this.isReport) {
          let now = new Date();
          localStorage.setItem("Date_report", now.getTime());
          localStorage.setItem(
            "report_filters",
            JSON.stringify(this.selectedValues)
          );
        } else if (this.isSplits) {
          let now = new Date();
          localStorage.setItem("Date_splits", now.getTime());
          localStorage.setItem(
            "splits_filters",
            JSON.stringify(this.selectedValues)
          );
        } else {
          let now = new Date();
          localStorage.setItem("Date", now.getTime());
          localStorage.setItem("filters", JSON.stringify(this.selectedValues));
        }
      } else {
        if (this.isReport) {
          localStorage.removeItem("report_filters");
          localStorage.removeItem("Date_report");
        } else if (this.isSplits) {
          localStorage.removeItem("splits_filters");
          localStorage.removeItem("Date_splits");
        } else {
          localStorage.removeItem("filters");
          localStorage.removeItem("Date");
        }
      }
    }
  },
  computed: {
    ...mapGetters(["customParams", "getProfile", "searchOptions"]),
    optionList() {
      let cps = this.customParams;
      let so = this.searchOptions.slice();
      if (cps.length > 0) {
        cps.forEach(el => {
          el.show = true;
          el.type = "text";
          el.value = "";
          el.is_cp = true;
        });
      }
      return so.concat(cps);
    },
    defaultMonths() {
      let start = moment()
        .add(-1, "month")
        .date(1)
        .format("YYYY-MM-DD");
      let end = moment()
        .date(1)
        .format("YYYY-MM-DD");
      return [start, end];
    },
    kops() {
      return [this.amount_rangeFrom * 100, this.amount_rangeTo * 100];
    },
    termList() {
      if (this.isSplits)
        return this.terminalList.filter(el => el.is_split == true);
      else {
        let merch = this.request.merchants;
        if (merch.length == 0) {
          return this.terminalList;
        } else {
          let tList = [];
          merch.forEach(el => {
            let filtered = this.terminalList.filter(
              item => item.merchant_id == el
            );
            tList = tList.concat(filtered);
          });
          return tList;
        }
      }
    },
    splitTermList() {
      if (this.isSplits) {
        return this.terminalList.filter(el => el.is_split_child);
      }
    },
    filterStatusList() {
      let terminals = this.terminalList;
      let states = this.statusList;
      let isPaid = terminals.filter(el => el.is_payout).length > 0;
      if (isPaid) return states;
      else
        return states.filter(
          el => el.id != 13 && el.id != 14 && el.id != 15 && el.id != 16
        );
    },
    errorList() {
      return _.omit(errors, "message");
    }
  },
  created() {
    if (/bo-dev/.test(window.location.origin))
      localStorage.removeItem("filters");
    this.resetOptions();
    this.loadFilters();
  },
  directives: { mask },
  components: {
    SearchComponent,
    InputSearch
  }
};
</script>

<style lang="sass"></style>
